import { FONT, PALETTE, SPACING, TYPEFACE, styled } from "@dexibit/styles";

export const Root = styled("div")`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.xxlarge} ${SPACING.large};
  text-align: center;
  background-color: ${PALETTE.BACKGROUND_BASE};
`;

export const Brand = styled("div")`
  position: absolute;
  top: ${SPACING.large};
  left: ${SPACING.large};
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.small};
`;

export const Panel = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.large};
  max-width: 34rem;
  width: 100%;

  @media (prefers-reduced-motion: no-preference) {
    & > * {
      opacity: 0;
      transform: translateY(8px);
      animation: maintenanceRise 560ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
    }
    & > *:nth-child(1) {
      animation-delay: 60ms;
    }
    & > *:nth-child(2) {
      animation-delay: 130ms;
    }
    & > *:nth-child(3) {
      animation-delay: 200ms;
    }
    & > *:nth-child(4) {
      animation-delay: 270ms;
    }
  }

  @keyframes maintenanceRise {
    to {
      opacity: 1;
      transform: none;
    }
  }
`;

export const IconWrap = styled("div")`
  display: inline-flex;
  font-size: 44px;
  line-height: 1;
  color: ${PALETTE.PRIMARY_BASE};
`;

export const TextGroup = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.small};
`;

export const Title = styled("h1")`
  margin: 0;
  font-size: ${FONT.HEADING_MEDIUM.fontSize};
  font-weight: ${FONT.HEADING_MEDIUM.fontWeight};
  line-height: ${FONT.HEADING_MEDIUM.lineHeight};
  letter-spacing: ${FONT.HEADING_MEDIUM.letterSpacing};
  color: ${PALETTE.TEXT_EMPHASIS_HIGHEST};
  text-wrap: balance;
`;

export const Lede = styled("p")`
  margin: 0;
  max-width: 46ch;
  font-size: ${FONT.BODY_LARGE.fontSize};
  line-height: ${TYPEFACE.LINE_HEIGHTS.RELAXED};
  color: ${PALETTE.TEXT_EMPHASIS_REGULAR};
`;

export const HomeNote = styled("p")`
  margin: 0;
  font-size: ${FONT.BODY_REGULAR.fontSize};
  line-height: ${TYPEFACE.LINE_HEIGHTS.NORMAL};
  color: ${PALETTE.TEXT_EMPHASIS_REGULAR};

  a {
    color: ${PALETTE.PRIMARY_BASE};
    font-weight: ${TYPEFACE.FONT_WEIGHTS.MEDIUM};
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  a:focus-visible {
    outline: 2px solid ${PALETTE.COMPONENT_PRIMARY_ACTIVE};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const Support = styled("div")`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.regular};
  margin-top: ${SPACING.regular};
`;

export const SupportLabel = styled("span")`
  font-size: ${FONT.BODY_SMALL.fontSize};
  color: ${PALETTE.TEXT_EMPHASIS_LOW};
`;

export const Contact = styled("a")`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.small};
  padding: ${SPACING.xsmall} ${SPACING.regular} ${SPACING.xsmall} ${SPACING.xsmall};
  border-radius: 999px;
  border: 1px solid ${PALETTE.SURFACE_BORDER};
  background-color: ${PALETTE.SURFACE_BASE};
  text-decoration: none;
  transition:
    border-color 120ms ease,
    background-color 120ms ease;

  &:hover {
    border-color: ${PALETTE.PRIMARY_CONTRAST_LOW};
    background-color: ${PALETTE.PRIMARY_CONTRAST_LOWEST};
  }
  &:focus-visible {
    outline: 2px solid ${PALETTE.COMPONENT_PRIMARY_ACTIVE};
    outline-offset: 2px;
  }
`;

export const ContactText = styled("span")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

export const ContactName = styled("span")`
  font-size: ${FONT.BODY_REGULAR.fontSize};
  font-weight: ${TYPEFACE.FONT_WEIGHTS.MEDIUM};
  line-height: 1.2;
  color: ${PALETTE.TEXT_EMPHASIS_HIGHEST};
`;

export const ContactEmail = styled("span")`
  font-size: ${FONT.BODY_SMALL.fontSize};
  line-height: 1.3;
  color: ${PALETTE.PRIMARY_BASE};
`;
